import { useMemo } from 'react';

import { ButtonProps } from '@mui/material';

import { PropertyStatus } from '@arrived/common';
import { useGetPropertyStylingStatus } from '@arrived/contexts';
import { Offering } from '@arrived/models';

import { ThemeFunction } from '../utils';

interface TypePropertyStatusMapItem {
  barColor?: ThemeFunction<string>; // gradient/color for progress bar
  palette?: ButtonProps['color'];
}

export const PROPERTY_STATUS_MAP: Record<PropertyStatus, TypePropertyStatusMapItem> = {
  [PropertyStatus.TRENDING]: {
    barColor: ({ palette }) => palette.warning.main,
    palette: 'warning',
  },
  [PropertyStatus.SOLD_OUT]: {
    barColor: ({ palette }) => palette.neutrals.gray,
    palette: 'secondary',
  },
  [PropertyStatus.PAUSED]: {
    barColor: ({ palette }) => palette.warning.main,
    palette: 'secondary',
  },
  [PropertyStatus.CLOSE]: {
    barColor: ({ palette }) => palette.warning.main,
    palette: 'secondary',
  },
  [PropertyStatus.NEW]: {
    barColor: ({ palette }) => palette.primary.main,
    palette: 'secondary',
  },
  [PropertyStatus.COMING_SOON]: {
    barColor: ({ palette }) => palette.warning.main,
    palette: 'secondary',
  },
  [PropertyStatus.OWNER]: {
    palette: 'secondary',
  },
  [PropertyStatus.FUTURE_MARKET]: {
    palette: 'secondary',
  },
  [PropertyStatus.LIMITED_OFFERING]: {
    barColor: ({ palette }) => palette.warning.main,
  },
};

export const usePropertyStyles = (offering: Offering) => {
  const getPropertyStyles = useGetPropertyStylingStatus();
  return useMemo(() => PROPERTY_STATUS_MAP[getPropertyStyles(offering)], [getPropertyStyles, offering]);
};
